import * as React from 'react';
import ReactSlick, { Settings } from 'react-slick';

import { PictureProfile } from '../../../ResizedImage/PictureProfile.csharp';
import { ImageGalleryItemViewModel } from '../../Partials/ImageGallery/ImageGalleryItemViewModel.csharp';
import { ImageGalleryThumbnails } from '../../Partials/ImageGallery/ImageGalleryThumbnails';
import { ResponsivePicture } from '../ResponsivePicture/ResponsivePicture';

interface ModalImageGalleryProps {
    items: ImageGalleryItemViewModel[];
    profile: PictureProfile;
    thumbnailsProfile: PictureProfile;
    selectedImage?: number;
    onSlideChange: (slideIndex: number) => void;
}

export class ModalImageGallery extends React.Component<ModalImageGalleryProps> {
    slider = React.createRef<ReactSlick>();

    private readonly sliderSettings = {
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
        lazyLoad: 'ondemand',
        fade: true,
        initialSlide: this.props.selectedImage || 0,
        useTransform: false
    } as Settings;

    render() {
        return (
            <div className="ModalImageGallery__Content">
                <ReactSlick {...this.sliderSettings} beforeChange={(current, next) => this.props.onSlideChange(next)} ref={this.slider}>
                    {this.props.items.map((item: ImageGalleryItemViewModel, index: number) => (
                        <ResponsivePicture key={`ImageGalleryItem-${index}`} model={item.picture} profile={this.props.profile} isLazyLoaded />
                    ))}
                </ReactSlick>
                {this.props.items?.length > 1 && (
                    <ImageGalleryThumbnails
                        images={this.props.items}
                        pictureProfile={this.props.thumbnailsProfile}
                        selectedImage={this.props.selectedImage || 0}
                        onlyHorizontal
                        selectImage={(i) => {
                            this.props.onSlideChange(i);
                            this.slider.current?.slickGoTo(i);
                        }}
                    />
                )}
            </div>
        );
    }
}
